export default {
  Article: '文章',
  Articles: '文章',
  Post: '发表',
  ArticleCover: '文章封面',
  'Language Configuration': '语言配置',
  'Site Configuration': '站点配置',
  'Time Used': '用时',
  'What to write': '写点什么',
  'Build Language': '构建语言',
  'Build All Languages': '构建所有语言',
};
